export enum PopupAlertTheme {
  success = "success",
  danger = "danger",
  info = "info",
  warning = "warning",
  secondary = "secondary",
}